<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader />
      </div>
    </md-app-toolbar>
    <div class="page-container">
      <md-app
        md-mode="fixed">
        <md-app-content class="page-content">
          <div class="page-layout">
            <div class="main__panel">
              <md-content>
                <md-table
                  v-model="buildingsData"
                  :md-sort.sync="currentSort"
                  :md-sort-order.sync="currentSortOrder"
                  :md-sort-fn="customSort"
                  md-card>
                  <md-table-toolbar>
                    <h1 class="md-title m-10">
                      Paramétrage du déploiement EnR
                      <div class="md-body-1 m-10">Ces paramètres sont appliqués lorsque une action qui les utilise est appliquée au bâtiment mentionné dans le cadre d'un scénario.</div>
                    </h1>
                  </md-table-toolbar>

                  <md-table-empty-state
                    md-label="Aucun résultat"
                    md-description="Aucun bâtiment trouvé pour cette recherche. Veuillez modifier vos critères." />

                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }">
                    <md-table-cell
                      md-label="Site"
                      md-sort-by="parent__name">
                      <div>
                        <strong>{{ item.site_name }}</strong>
                      </div>
                    </md-table-cell>
                    <md-table-cell
                      md-label="Bâtiment"
                      md-sort-by="name">
                      {{ item.name }}
                    </md-table-cell>
                    <md-table-cell
                      md-label="Solaire photovoltaïque"
                      md-sort-by="potential_solar_photovoltaic_peak_power">
                      <template
                        v-if='item.potential_solar_photovoltaic_peak_power'>
                        {{ item.potential_solar_photovoltaic_peak_power }} kWc
                      </template>
                      <template
                        v-else>
                        -
                      </template>
                    </md-table-cell>
                    <md-table-cell
                      md-label="ECS solaire"
                      md-sort-by="potential_dhw_solar_thermal_area">
                      <template
                        v-if='item.potential_dhw_solar_thermal_area'>
                        {{ item.potential_dhw_solar_thermal_area }} m²
                      </template>
                      <template
                        v-else>
                        -
                      </template>
                    </md-table-cell>
                    <md-table-cell
                      md-label="Modifier">
                      <md-button
                        @click="showBuildingREDialog(item)"
                        class="md-primary">
                        Modifier
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <div class="pagination">
                  <div
                    v-if='buildingsData.length > 0'>
                    <div>
                      <md-button
                        v-if="previousOffset != null"
                        @click='getPreviousPage()'
                        class="md-icon-button md-primary md-raised">
                        <md-icon>navigate_before</md-icon>
                      </md-button>
                    </div>
                    <div class="pagination__count">
                      {{ resultsFrom }} à {{ resultsTo }} sur {{ resultsCount }}
                    </div>

                    <div>
                      <md-button
                        v-if="nextOffset != null"
                        @click='getNextPage()'
                        class="md-icon-button md-primary md-raised">
                        <md-icon>navigate_next</md-icon>
                      </md-button>
                    </div>
                  </div>
                </div>
              </md-content>
            </div>
            <div class="filters__panel">
              <md-toolbar
                class="md-primary">
                <md-icon>
                  sort
                </md-icon>
                <span class="md-title">Filtres</span>
              </md-toolbar>
              <md-field>
                <label>Filtrer par nom</label>
                <md-input v-model="displayFilters.name" />
              </md-field>
              <div>
                <h3>
                  <md-checkbox
                    class="md-primary"
                    v-model="selectedAllFunctions">
                    Fonctions
                  </md-checkbox>
                </h3>
                <div
                  v-for="func in functionsList"
                  :key="func.id">
                  <md-checkbox
                    class="md-primary"
                    :value="func.id"
                    v-model="displayFilters.selectedFunctions">
                    {{ func.label }}
                  </md-checkbox>
                </div>
              </div>
              <div>
                <h3>
                  <md-checkbox
                    class="md-primary"
                    v-model="selectedAllStatus">
                    Statuts
                  </md-checkbox>
                </h3>
                <div
                  v-for="status in statusList"
                  :key="status.id">
                  <md-checkbox
                    class="md-primary"
                    :value="status.id"
                    v-model="displayFilters.selectedStatus">
                    {{ status.name }}
                  </md-checkbox>
                </div>
              </div>
              <div
                v-if='tagsList.length > 0'>
                <h3>Tags</h3>
                <div
                  v-for="tag in tagsList"
                  :key="tag.id">
                  <md-checkbox
                    class="md-primary"
                    :value="tag.id"
                    v-model="displayFilters.selectedTags">
                    {{ tag.name }}
                  </md-checkbox>
                </div>
              </div>
            </div>
          </div>
        </md-app-content>
      </md-app>

      <md-dialog
        :md-fullscreen='true'
        :md-active.sync="buildingREModal.showDialog">
        <md-dialog-title>Paramétrage du déploiement EnR</md-dialog-title>
        <md-dialog-content
          v-if='buildingREModal.building'>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Site: <strong>{{ buildingREModal.building.site_name }}</strong></div>
              <div class="md-layout-item">Surface: <strong>{{ buildingREModal.building.usable_area|formatIntNumber }}</strong> m² SU</div>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Bâtiment: <strong>{{ buildingREModal.building.name }}</strong></div>
              <div class="md-layout-item">Consommation pour l'usage ECS: <strong>{{ buildingREModal.building.dhw_consumptions|formatIntNumber }}</strong> kWh ({{ buildingREModal.building.consumptions_year }})</div>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item"/>
              <div class="md-layout-item">Consommation totale d'électricité : <strong>{{ buildingREModal.building.electricity_consumptions|formatIntNumber }}</strong> kWh ({{ buildingREModal.building.consumptions_year }})</div>
            </div>
          </div>

          <div class="md-title m-20">Potentiel pour le solaire photovoltaïque</div>
          <div class="md-layout md-gutter m-20">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Taux de conversion de la production annuelle par kWc en kWh:</div>
              <div class="md-layout-item">{{ userSettings.photovoltaic_kwc_to_kwh_rate }} kWh/an.kWc</div>
            </div>
          </div>
          <div class="md-layout md-gutter m-20">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item md-size-50">Puissance supplémentaire à installer:</div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <md-input
                    v-model="buildingREModal.building.potential_solar_photovoltaic_peak_power"
                    type="number"
                    placeholder="kW crète" />
                  <span class="md-suffix">kWc</span>
                </md-field>
              </div>
            </div>
          </div>
          <div
            class="md-layout md-gutter"
            v-if="equivalentPeakPower">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Équivalent à environ:
              </div>
              <div class="md-layout-item">
                {{ equivalentPeakPower }} &nbsp; kWh/an
              </div>
            </div>
          </div>

          <div class="md-title m-20">Potentiel pour l'ECS solaire thermique</div>
          <div class="md-layout md-gutter m-20">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Taux de conversion de la production annuelle par m² en kWh:</div>
              <div class="md-layout-item">{{ userSettings.solar_thermal_m2_to_kwh_rate }} kWh/an.m²</div>
            </div>
          </div>
          <div class="md-layout md-gutter m-20">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item md-size-50">m² d'équipement supplémentaire à installer :</div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <md-input
                    v-model="buildingREModal.building.potential_dhw_solar_thermal_area"
                    type="number"
                    placeholder="m² équipement" />
                  <span class="md-suffix">m²</span>
                </md-field>
              </div>
            </div>
          </div>
          <div
            class="md-layout md-gutter"
            v-if="equivalentSolarThermalArea">
            <div class="md-layout-item md-layout md-gutter">
              <div class="md-layout-item">Équivalent à environ:
              </div>
              <div class="md-layout-item">
                {{ equivalentSolarThermalArea }} &nbsp; kWh/an
              </div>
            </div>
          </div>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="hideBuildingREDialog()">
            Fermer
          </md-button>
          <md-button
            class="md-primary"
            @click="updateBuildingRE()">
            Enregistrer
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import session from '../api/session'
import axios from 'axios'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
var _ = require('lodash')

export default {
  name: 'BuildingStockRenewableEnergies',
  mixins: [ValuesDisplayMixin],
  components: { BuildingStockHeader },
  data () {
    return {
      functionsList: [],
      tagsList: [],
      apiLoaded: false,
      currentSort: 'parent__name',
      currentSortOrder: 'desc',
      statusList: [
        {id: 1, name: 'Propriétaire occupant'},
        {id: 2, name: 'Propriétaire bailleur'},
        {id: 3, name: 'Locataire'},
        {id: 4, name: 'Copropriétaire'}
      ],
      buildingsData: [],
      userSettings: {
        photovoltaic_kwc_to_kwh_rate: null,
        solar_thermal_m2_to_kwh_rate: null
      },
      buildingREModal: {
        showDialog: false,
        building: null,
        original_potential_dhw_solar_thermal_area: null,
        original_potential_solar_photovoltaic_peak_power: null
      },
      selectedAllFunctions: true,
      selectedAllStatus: true,
      displayFilters: {
        name: '',
        selectedFunctions: [],
        selectedTags: [],
        selectedStatus: [1, 2, 3, 4]
      },
      apiOffset: 0,
      resultsTotalCount: 0,
      resultsCount: 0,
      resultsFrom: 0,
      resultsTo: 0,
      previousOffset: null,
      nextOffset: null
    }
  },
  created: function () {
    // _.debounce est une fonction fournie par lodash pour limiter la fréquence
    // d'exécution d'une opération particulièrement couteuse.
    // Pour en savoir plus sur la fonction `_.debounce` (et sa cousine
    // `_.throttle`), visitez : https://lodash.com/docs#debounce
    this.debouncedGetSitesData = _.debounce(this.getBuildingsData, 1)
  },
  mounted: function () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Parc bâti')
    app.$store.dispatch('routing/update_return_kwargs', null)
    app.loadApi()
  },
  watch: {
    selectedAllFunctions: function (val) {
      var app = this
      app.displayFilters.selectedFunctions = []

      if (val === true) {
        for (var i in app.functionsList) {
          app.displayFilters.selectedFunctions.push(app.functionsList[i]['id'])
        }
      }
    },
    selectedAllStatus: function (val) {
      var app = this
      app.displayFilters.selectedStatus = []

      if (val === true) {
        app.displayFilters.selectedStatus = [1, 2, 3]
      }
    },
    displayFilters: {
      handler (val) {
        this.getBuildingsData(true)
      },
      deep: true
    }
  },
  computed: {
    equivalentPeakPower () {
      var app = this
      if (app.userSettings.photovoltaic_kwc_to_kwh_rate && app.buildingREModal.building && app.buildingREModal.building.potential_solar_photovoltaic_peak_power) {
        return parseInt(app.userSettings.photovoltaic_kwc_to_kwh_rate * app.buildingREModal.building.potential_solar_photovoltaic_peak_power).toLocaleString()
      } else {
        return null
      }
    },
    equivalentSolarThermalArea () {
      var app = this
      if (app.userSettings.solar_thermal_m2_to_kwh_rate && app.buildingREModal.building && app.buildingREModal.building.potential_dhw_solar_thermal_area) {
        return parseInt(app.userSettings.solar_thermal_m2_to_kwh_rate * app.buildingREModal.building.potential_dhw_solar_thermal_area).toLocaleString()
      } else {
        return null
      }
    }
  },
  methods: {
    getNextPage: function () {
      var app = this
      app.apiOffset = app.nextOffset
      app.getBuildingsData(false)
    },
    getPreviousPage: function () {
      var app = this
      app.apiOffset = app.previousOffset
      app.getBuildingsData(false)
    },
    showBuildingREDialog (building) {
      var app = this
      app.buildingREModal.showDialog = true
      app.buildingREModal.building = building
      app.buildingREModal.original_potential_dhw_solar_thermal_area = app.buildingREModal.building.potential_dhw_solar_thermal_area
      app.buildingREModal.original_potential_solar_photovoltaic_peak_power = app.buildingREModal.building.potential_solar_photovoltaic_peak_power
    },
    hideBuildingREDialog () {
      var app = this
      app.buildingREModal.building.potential_dhw_solar_thermal_area = app.buildingREModal.original_potential_dhw_solar_thermal_area
      app.buildingREModal.building.potential_solar_photovoltaic_peak_power = app.buildingREModal.original_potential_solar_photovoltaic_peak_power
      app.buildingREModal.showDialog = false
      app.buildingREModal.building = null
      app.buildingREModal.original_potential_dhw_solar_thermal_area = null
      app.buildingREModal.original_potential_solar_photovoltaic_peak_power = null
    },
    updateBuildingRE () {
      var app = this
      let placeId = app.buildingREModal.building.id
      let formData = {
        'potential_dhw_solar_thermal_area': null,
        'potential_solar_photovoltaic_peak_power': null
      }

      if (app.buildingREModal.building.potential_dhw_solar_thermal_area !== '') {
        formData.potential_dhw_solar_thermal_area = app.buildingREModal.building.potential_dhw_solar_thermal_area
      }

      if (app.buildingREModal.building.potential_solar_photovoltaic_peak_power !== '') {
        formData.potential_solar_photovoltaic_peak_power = app.buildingREModal.building.potential_solar_photovoltaic_peak_power
      }

      session.put(`/api/userdata/buildings-renewable-energies/${placeId}/`,
        formData).then(function (buildingResponse) {
        let building = buildingResponse.data
        let buildingIndex = app.buildingsData.findIndex(function (s) { return s.id === placeId })
        app.$set(app.buildingsData, buildingIndex, building)
        app.buildingREModal.showDialog = false
        app.buildingREModal.building = null
        app.buildingREModal.original_potential_dhw_solar_thermal_area = null
        app.buildingREModal.original_potential_solar_photovoltaic_peak_power = null
      }).catch(function (error) {
        var response = error.response
        if (response.status === 500) {
          app.buildingREModal.showDialog = false
        }
      })
    },
    getBuildingsData: function (resetPagination) {
      var app = this

      if (resetPagination === true) {
        app.apiOffset = 0
        app.resultsCount = 0
        app.resultsFrom = 0
        app.resultsTo = 0
        app.previousOffset = null
        app.nextOffset = null
      }

      if (app.apiLoaded === true) {
        var queryParams = {
          limit: 8,
          offset: app.apiOffset,
          sort_by: app.currentSort,
          sort_order: app.currentSortOrder}

        if (app.displayFilters.name.length > 0) {
          queryParams.name = app.displayFilters.name
        }

        if (app.displayFilters.selectedFunctions.length !== app.functionsList.length) {
          queryParams.functions = app.displayFilters.selectedFunctions
        }

        if (app.displayFilters.selectedStatus.length !== app.statusList.length) {
          queryParams.status = app.displayFilters.selectedStatus
        }

        if (app.displayFilters.selectedTags.length > 0) {
          queryParams.tags = app.displayFilters.selectedTags
        }

        session.get('/api/userdata/buildings-renewable-energies/', {params: queryParams}).then(function (buildingsResponse) {
          app.buildingsData = buildingsResponse.data.results
          app.apiOffset = buildingsResponse.data.offset
          app.resultsCount = buildingsResponse.data.count
          app.resultsTotalCount = buildingsResponse.data.total_count
          app.resultsFrom = buildingsResponse.data.min
          app.resultsTo = buildingsResponse.data.max
          app.previousOffset = buildingsResponse.data.previous_offset
          app.nextOffset = buildingsResponse.data.next_offset
        })
      }
    },
    loadApi () {
      var app = this

      app.$store.dispatch('loading/begin_loading')

      let userSettingsRequest = session.get('/api/usersettings/group-settings/')
      let functionsRequest = session.get('/api/parameters/functions/')
      let tagsRequest = session.get('/api/userdata/tags/')

      axios.all([userSettingsRequest, functionsRequest, tagsRequest])
        .then(axios.spread(function (userSettingsResponse, functionResponse, tagsResponse) {
          if (userSettingsResponse.data.length > 0) {
            app.userSettings = userSettingsResponse.data[0]
          }
          app.functionsList = functionResponse.data

          app.functionsList.forEach(function (f) {
            app.displayFilters.selectedFunctions.push(f.id)
          })

          app.tagsList = tagsResponse.data

          app.apiLoaded = true
          app.getBuildingsData(true)
          app.$store.dispatch('loading/end_loading')
        }))
    },
    customSort (value) {
      var app = this
      app.getBuildingsData(true)
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";
.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: min-content;
}

.filters__panel {
  background-color: darken(project-theme("white"), 4);
  border-left: 1px solid darken(project-theme("white"), 10);
  padding: 20px;
  right: 0;
  bottom: 0;
  top: 64px;
  width: 15%;
}

.main__panel {
  padding: 20px;
  width: 85%;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 20px;
  }
}

.p-10 {
  padding: 20px 40px !important;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 100%;
    background: #86ad19;
    left: 0;
    top: 0;
  }
}
.m-20 {
  margin-top: 20px;
}
.m-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.pagination{
  padding: 10px;
  margin-top: 20px;
  border-top: 1px solid darken(white, 6);
  display: flex;
  justify-content: flex-end;

  >div{
    display: flex;
    align-items: center;
  }
  &__count{
    padding:.5rem 1rem;
  }
}
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/BuildingStockRenewableEnergies.vue